jQuery(document).ready(function ($) {
    $('.form-group [data-enabled-by]').each(function () {
        const enabledEl = $(this);
        const enablersStringRaw = enabledEl.data('enabled-by');

        if (!enablersStringRaw.length) {
            return;
        }

        updateEnabledState(enabledEl);

        getEnablers(enablersStringRaw).forEach(function (enabler) {
            $(enabler.el).on('change', function () {
                updateEnabledState(enabledEl, false);
            });
        });
    });

    function getEnablers(enablersStringRaw) {
        const enablers = [];

        enablersStringRaw.split(',').forEach(function (enablerStringRaw) {
            let enableOnValue = null;
            let enablerString = enablerStringRaw.slice(0);
            const separatorPosition = enablerStringRaw.indexOf(':');

            if (separatorPosition !== -1) {
                enablerString = enablerStringRaw.slice(0, separatorPosition);
                enableOnValue = enablerStringRaw.slice(separatorPosition + 1);
            }

            enablers.push({
                el: $(`[name="${enablerString}"]`)[0],
                enableOnValue,
            });
        });

        return enablers;
    }

    function updateEnabledState(enabledEl, isInitialPageLoad = true) {
        const enabledElFormGroup = enabledEl.parents('.form-group');
        let shouldBeEnabled = true;

        getEnablers(enabledEl.data('enabled-by')).forEach(function (enabler) {
            if (!doesElSatisfyEnableOnValue(enabler.el, enabler.enableOnValue)) {
                shouldBeEnabled = false;
            }
        });

        if (shouldBeEnabled) {
            enabledElFormGroup.show();
        } else {
            enabledElFormGroup.hide();
        }
    }

    function doesElSatisfyEnableOnValue(el, enableOnValue) {
        if (el.tagName === 'SELECT') {
            if (enableOnValue) {
                return el.value === enableOnValue;
            }
            return Boolean(el.value);
        }
        if (el.tagName === 'INPUT' && el.type === 'checkbox') {
            return el.checked;
        }

        return false;
    }
});
